import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserSettings } from "services/auth/actions";
import { Carousel } from "react-responsive-carousel";
import { completeSetup } from "./actions";
import { useHistory } from "react-router-dom";
import { getSelfUser } from "../../../../services/auth/actions";
import layoutHOC from "HOC/layoutHOC";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step5 from "./step5";
import Step6 from "./step6";
import Step7 from "./step7";

import "./carousel.scss";
import "./style.scss";
import "./invoice.scss";
import useTheme from "../../../../hooks/useTheme";



const Setup = ({ step, setStep }) => {

	const [settings, setSettings] = useState({
		shop: {},
		user: {},
	});
	const dispatch = useDispatch();

	useEffect(() => {

		document.title = "Setup your Paylix Shop"

		dispatch(getUserSettings())
			.then((res) => {
				setSettings(res.data.settings);
			});
	}, []);

	let history = useHistory();

	const skipStep = () => {
		setStep(step + 1)
	}

	const skipSetup = () => {
		dispatch(completeSetup())
			.then(() => {
				dispatch(getSelfUser())
					.then(() => history.push({
						pathname: "/",
						hash: "#onboarding",
					}))
			})
	};

	const options = {
		autoFocus: false,
		autoPlay: false,
		infiniteLoop: false,
		emulateTouch: false,
		showArrows: false,
		showStatus: false,
		showIndicators: false,
		showThumbs: false,
		swipeable: false,
		useKeyboardArrows: false,
		transitionTime: 500,
		selectedItem: step,
	}
	// style={{ background: "var(--black0)"}}
	return (
		<>
			<div className="setup-screen">
	            <div className="setup-screen-wrapper">

		           <div className="setup-screen-body w-100">
			           <Carousel {...options}>
						   <div className={`setup-screen-step ${step === 0 && "current"}`}>
							   {step === 0 && <Step1 settings={settings} setStep={() => setStep(step + 1)} skipStep={skipStep} />}
						   </div>

						   <div className={`setup-screen-step ${step === 1 && "current"}`}>
							   {step === 1 && <Step2 settings={settings} setStep={() => setStep(step + 1)} skipStep={skipStep} />}
						   </div>

						   <div className={`setup-screen-step ${step === 2 && "current"}`}>
							   {step === 2 && <Step3 settings={settings} setStep={() => setStep(step + 1)} skipStep={skipStep} />}
						   </div>

						   <div className={`setup-screen-step ${step === 3 && "current"}`}>
							   {step === 3 && <Step4 settings={settings} setStep={() => setStep(step + 1)} skipStep={skipStep} />}
						   </div>

						   <div className={`setup-screen-step ${step === 4 && "current"}`}>
							   {step === 4 && <Step5 settings={settings} setStep={() => setStep(step + 1)} skipStep={skipStep} />}
						   </div>

						   <div className={`setup-screen-step ${step === 5 && "current"}`}>
							   {step === 5 && <Step6 settings={settings} setStep={() => setStep(step + 1)} skipStep={skipStep}  />}
						   </div>

						   <div className={`setup-screen-step ${step === 6 && "current"}`}>
							   {step === 6 && <Step7 skipSetup={skipSetup} />}
						   </div>
			           </Carousel>
		           </div>
	            </div>

			</div>
		</>
	)

}

export default layoutHOC(Setup);
